import { useState, useEffect, useCallback } from "react";
import { urlApi } from "../helpers/functionHelpers";
import { hacerSolicitud } from "../helpers/apiClient";
import { useAuth } from "./useAuth";
import useEmpresaStore from "../context/empresaStore";

const useReservasPendientes = () => {
  const { renovarToken, cerrarSesion } = useAuth();
  const { empresa_ids, empresa_id } = useEmpresaStore();
  const [reservas, setReservas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Función para obtener las reservas agrupadas por folio
  const fetchReservas = useCallback(async () => {
    setLoading(true);
    setError(null);
    const idsParam = empresa_ids ? empresa_ids.join(',') : empresa_id;

    try {
      const data = await hacerSolicitud(
        `${urlApi}/api/solicitudes-pendientes-agrupadas?empresa_id=${idsParam}`,
        { method: "GET" },
        renovarToken,
        cerrarSesion
      );

      setReservas(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [renovarToken, cerrarSesion, empresa_ids, empresa_id]);

  // ✅ Carga inicial de datos
  useEffect(() => {
    fetchReservas();
  }, [fetchReservas]);

  return { reservas, loading, error, actualizarReservas: fetchReservas };
};

export default useReservasPendientes;
